document.addEventListener("turbolinks:load", function () {
    document.addEventListener("trix-attachment-add", function (event) {
        const attachment = event.attachment;
        const editorElement = document.querySelector("trix-editor");

        if (!editorElement || !attachment.file) return;

        // Wait for Trix to finish processing the file
        if (attachment.file) {
            // Wait for attachment to be uploaded (or considered done)
            attachment.setAttributes({ customPending: true });

            attachment.uploaded = () => {
                attachment.setAttributes({ customPending: false });
                callOcrJob(attachment);
            };

            // Fallback in case `uploaded` doesn’t fire
            setTimeout(() => {
                if (attachment.getAttribute("customPending")) {
                    callOcrJob(attachment);
                }
            }, 800);
        }
    });
});

function callOcrJob(attachment) {
    const csrfToken = document.querySelector("[name='csrf-token']").getAttribute("content");

    const fileReader = new FileReader();
    fileReader.onloadend = function () {
        const base64image = fileReader.result;

        fetch('/azure_vision', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': csrfToken
            },
            body: JSON.stringify({ image: base64image })
        })
            .then(response => {
                if (!response.ok) {
                    return response.text().then(errorText => {
                        throw new Error(errorText);
                    });
                }
                return response.json();
            })
            .then(data => {
                const element = document.querySelector("trix-editor");

                try {
                    // Insert just before the last attachment (safely at the end for now)
                    element.editor.setSelectedRange([0, 0]);
                    element.editor.insertString("\n" + data.text + "\n");
                } catch (err) {
                    console.error("Trix insert error:", err);
                    alert("Failed to insert OCR text. Here's the result:\n\n" + data.text);
                }
            })
            .catch(error => {
                console.error('Error:', error);
                alert('OCR failed: ' + error.message);
            });
    };

    fileReader.readAsDataURL(attachment.file);
}
